module.exports = __webpack_public_path__ + "img/sales_icon_pink.b62c4265.svg";